module.exports = __webpack_public_path__ + "img/horizontal_4_5_2.eca614b7.png";